<template>
  <div id="app">
    <keep-alive>
      <router-view class="router-view" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <van-tabbar
      v-if="$route.meta.hasBar"
      v-model="active"
      active-color="#f19800"
      inactive-color="#838383"
    >
      <van-tabbar-item to="/" icon="home-o">首页</van-tabbar-item>
      <!-- <van-tabbar-item to="/list" icon="apps-o">商品列表</van-tabbar-item> -->
      <van-tabbar-item to="/cart" v-if="cartNum>0" :badge="cartNum" icon="cart-o">购物车</van-tabbar-item>
      <van-tabbar-item to="/cart" v-else icon="cart-o">购物车</van-tabbar-item>
      <van-tabbar-item to="/my" icon="manager-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem, Divider } from "vant";
import api from "../src/api/base";
export default {
  components: {
    [Tabbar.name]: Tabbar,
    [Divider.name]: Divider,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      active: 0,
      cartNum: 0,
      icon1: {
        normal: require("./assets/icons/home-off.png"),
        active: require("./assets/icons/home-on.png")
      },
      icon2: {
        normal: require("./assets/icons/list-off.png"),
        active: require("./assets/icons/list-on.png")
      },
      icon3: {
        normal: require("./assets/icons/cart-off.png"),
        active: require("./assets/icons/cart-on.png")
      },
      icon4: {
        normal: require("./assets/icons/my-off.png"),
        active: require("./assets/icons/my-on.png")
      }
    };
  },
  methods: {
    getCartItemNum() {
      api.getCartItemNum({hideLoading:true}).then(res => {
        if (res.status == 0) {
          this.cartNum = res.result;
        }
      });
    }
  },
  created() {
    this.getCartItemNum()
  },
  updated() {
    this.getCartItemNum()
    console.log(this.$route);
  }
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
}
.van-tabbar {
  border-top: 1px solid #dedede;
}
.router-view {
  padding-bottom: 50px;
}
</style>
